import { groupDigits } from "./cell_formatter";
import messages from "./messages";

/**
 * The per-fund sync on the Latest by fund tab is one value:
 *
 *   null | { phase: "confirm", row } | { phase: "running", row }
 *        | { phase: "done", row, summary } | { phase: "failed", row, message }
 *
 * One value rather than a flag per row because be-admin runs one dashboard-started sync at a time
 * (a second one gets 409), so there is never more than one fund in flight to keep track of.
 */

/**
 * The phase a sync request that resolved moves to. HTTP 200 is not success on its own: be-admin
 * answers `status: false` when any chunk failed, and names those funds in `failed_fund_nos`.
 */
export function syncResultPhase(row, result, intl) {
  if (result.status) {
    return { phase: "done", row, summary: result.data };
  }
  const failed = result.data.failed_fund_nos || [];
  return {
    phase: "failed",
    row,
    message: intl.formatMessage(messages.syncFailedFunds, {
      fundCode: row.fund_code,
      fundNos: failed.length > 0 ? failed.join(", ") : row.fund_no
    })
  };
}

/**
 * The phase a sync request that threw moves to. be-admin's 400 and 409 bodies say exactly what is
 * wrong ("another sync is running", "fund not found"), so that text is shown as it came. Without a
 * body (a gateway timeout, a dropped connection) the run may still be going on the server, so the
 * operator is pointed at the sync status rather than told it failed.
 */
export function syncErrorPhase(row, error, intl) {
  if (error && error.detail) {
    return { phase: "failed", row, message: error.detail };
  }
  const reason =
    error && error.status
      ? intl.formatMessage(messages.errorStatus, { status: error.status })
      : intl.formatMessage(messages.syncNoResponse);
  return {
    phase: "failed",
    row,
    message: intl.formatMessage(messages.syncUnknownOutcome, { fundCode: row.fund_code, reason })
  };
}

/** The body of the result dialog for a done or failed phase. */
export function syncOutcomeText(sync, intl) {
  if (sync.phase === "failed") {
    return sync.message;
  }
  return intl.formatMessage(messages.syncDoneBody, {
    fundCode: sync.row.fund_code,
    upserted: groupDigits(sync.summary.rows_upserted),
    skipped: groupDigits(sync.summary.rows_skipped)
  });
}
